export const capitalizeFirstLetter = (text?: string): string => {
	if (text) {
		return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`
	}
	return ''
}

/**
 * Formattage d'une durée en minutes vers hh:mm
 * @param value
 */
export const formatMinutesToHHMM = (value: number): string => {
	const hours = Math.floor(value / 60)
	const minutes = value % 60
	return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}